export default __webpack_public_path__ + "static/media/038-washing face.dacb836a.svg";